import { Module } from 'vuex';
import { TllSyncStoreInterface } from '@/types/store/tllSyncStoreInterface';
import TLLSyncService from '@/services/wizard/tllSync.service';

const getDefaultState = () => {
  return {
    list: [],
    syncActive: false,
    listLoading: false,
  };
};

const tllSyncStore: Module<TllSyncStoreInterface, any> = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state: any) {
      const s: any = getDefaultState();
      Object.keys(s).forEach(key => {
        state[key] = s[key];
      });
    },
    listLoading(state, payload: boolean) {
      state.listLoading = payload;
    },
    listLoaded(state, payload: any) {
      if (payload.hotels) {
        state.list = payload.hotels;
      }
      state.syncActive = payload.global_switch;
    },
    globalSyncUpdated(state, payload: boolean) {
      state.syncActive = payload;
    },
  },
  actions: {
    getList({ commit }): any {
      commit('listLoading', true);
      return TLLSyncService.getHotels()
        .then((res: any) => {
          commit('listLoaded', res.data);
          return res;
        })
        .catch((error: any) => {
          return error;
        })
        .finally(() => {
          commit('listLoading', false);
        });
    },
    setGlobalSync({ commit }, activate: boolean): any {
      return TLLSyncService.setGlobalSync({ activate: activate })
        .then((res: any) => {
          commit('globalSyncUpdated', activate);
          return res;
        })
        .catch((error: any) => {
          return error;
        });
    },
    setHotelInquiry({ commit }, hotel_id: number): any {
      return TLLSyncService.hotelInquiry({ hotel_id: hotel_id });
    },
  },
};

export default tllSyncStore;
